var render = function render(){var _vm=this,_c=_vm._self._c;return _c('default-layout',[_c('event-navbar',{attrs:{"title":"Event Home"}}),_c('v-runtime-template',{attrs:{"template":_vm.event_content}}),_c('hr',{staticClass:"mx-3"}),_c('p',{staticClass:"text-center text-muted small mb-4"},[_c('router-link',{attrs:{"to":"/about"}},[_vm._v("Über diese App")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }